/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme } from "styles/theme";
import Icon from "uis/Icon";
import PersonalVisitLinkImg from "../../../../assets/imgs/visitors-onboard/personal-visit-link.png";
import { useEffect, useState } from "react";
import Button from "uis/Button";
import { RegisterVisitProcess } from "./process/registerVisitProcess";
import { gaEvent } from "utils/ga-utils";

const RootContainer = styled.div`
    display: flex;
    flex-direction: column;

    width: 100%;
    height: 100%;
`;

const Process = styled.div`
    height: 20%;
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: ${theme.neutral50};
`;

const Title = styled.div`
    height: 15%;
    font-size: 24px;
    font-weight: 500;
    color: ${theme.neutral900};

    display: flex;
    justify-content: center;
    align-items: center;
`;

const Content = styled.div`
    height: 50%;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    box-sizing: border-box;
    padding: 60px;
    background-color: ${theme.neutral50};
`;
const InfoSection = styled.div`
    flex-grow: 6;

    display: flex;
    flex-direction: column;
    gap: 30px;
`;
const IllustSection = styled.div`
    flex-grow: 4;
`;

const InfoText = styled.div`
    font-size: 18px;
    font-weight: 500;
    color: ${theme.neutral600};
`;

const Footer = styled.div`
    height: 15%;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    box-sizing: border-box;
    padding: 0px 50px;
    width: 100%;
    background-color: ${theme.neutral50};
`;
const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
`;
const SkipButton = styled.div`
    font-size: 18px;
    font-weight: 500;
    color: ${theme.neutral400};
    text-decoration: underline;

    cursor: pointer;
`;

type Props = {
    isFirst: boolean;
    onClickNext: () => void;
    onClickBack: () => void;
    onClickSkip: () => void;
}

export default function RegisterVisitPage(props: Props) {
    const { isFirst, onClickNext, onClickBack, onClickSkip } = props;

    useEffect(() => {
        if (isFirst) {
            gaEvent("첫 온보딩 - 방문 등록하기");
        } else { 
            gaEvent("온보딩 - 방문 등록하기");
        }
    }, []);

    return (
        <RootContainer>
            <Process>
                <RegisterVisitProcess></RegisterVisitProcess>
            </Process>
            <Title>나의 방문 관리 페이지에서 방문 일정을 등록해보세요.</Title>
            <Content>
                <InfoSection>
                    <div>
                        <InfoText>1. 일정 예약하기로 방문을 등록할 수 있어요.</InfoText>
                    </div>
                    <div css={css`
                        display: flex;
                        flex-direction: column;
                        gap: 20px;
                    `}>
                        <InfoText>2. 나의 방문 링크를 복사해 방문자에게 정보 입력을 요청하세요.</InfoText>
                        <img width="450" src={PersonalVisitLinkImg} alt="personalVisitLink"></img>
                    </div>
                </InfoSection>
                <IllustSection>
                    <Icon name="calendar-illust" color={theme.primary500} width={327}/>
                </IllustSection>
            </Content>
            <Footer>
                <SkipButton onClick={onClickSkip}>건너뛰기
                </SkipButton>
                <ButtonContainer>
                    <Button
                        title="이전"
                        type="secondary"
                        styles={{
                            container: css`
                                width: 120px;
                                height: 63px;
                            `,
                            text: css`
                                font-size: 18px;
                            `,
                        }}
                        onClick={onClickBack}
                    />
                    <Button
                        title="다음"
                        type="primary"
                        styles={{
                            container: css`
                                width: 260px;
                                height: 63px;
                            `,
                            text: css`
                                font-size: 18px;
                            `,
                        }}
                        onClick={onClickNext}
                    />
                </ButtonContainer>
            </Footer>
        </RootContainer>
    );
}
